/* OH_LENS_CONFIGURATOR_FLOW_V2 · 2026-07-21 */
(function () {
  'use strict';

  var SELECTOR_FOCUSABLE = [
    'a[href]', 'area[href]', 'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])',
    'textarea:not([disabled])', '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var COPY = {
    es: { incomplete: 'Completa las opciones de este paso para continuar.', choose: 'Elige una opción para continuar.', route: 'Elige cómo quieres facilitarnos tu graduación.', rx: 'Introduce tu graduación, sube una receta o pide ayuda a un óptico.', add: 'En progresivos falta la Adición (ADD) de ambos ojos.', pdChoice: 'Indica si conoces tu distancia pupilar o si necesitas ayuda.', pdValue: 'Introduce una distancia pupilar válida o elige «Necesito ayuda».', heightChoice: 'Indica si conoces la altura de montaje o si necesitas ayuda.', heightValue: 'Introduce la altura de ambos ojos o elige «Necesito ayuda».', appointment: 'Elige una fecha y una hora para hablar con el óptico.', invalid: 'Revisa este valor antes de continuar.', upload: 'Subir receta: elige una imagen o un archivo PDF.', opened: 'Asistente de lentes abierto.', closed: 'Asistente de lentes cerrado.' },
    en: { incomplete: 'Complete the options in this step to continue.', choose: 'Choose an option to continue.', route: 'Choose how you want to provide your prescription.', rx: 'Enter your prescription, upload it, or ask an optician for help.', add: 'Progressive lenses need the Addition (ADD) for both eyes.', pdChoice: 'Say whether you know your pupillary distance or need help.', pdValue: 'Enter a valid pupillary distance or choose “I need help”.', heightChoice: 'Say whether you know the fitting height or need help.', heightValue: 'Enter both fitting heights or choose “I need help”.', appointment: 'Choose a date and time to speak with an optician.', invalid: 'Check this value before continuing.', upload: 'Upload prescription: choose an image or PDF file.', opened: 'Lens assistant opened.', closed: 'Lens assistant closed.' },
    fr: { incomplete: 'Complétez les options de cette étape pour continuer.', choose: 'Choisissez une option pour continuer.', route: 'Choisissez comment nous transmettre votre ordonnance.', rx: 'Saisissez ou téléversez votre ordonnance, ou demandez de l’aide.', add: 'Les progressifs exigent l’Addition (ADD) des deux yeux.', pdChoice: 'Indiquez si vous connaissez votre écart pupillaire ou avez besoin d’aide.', pdValue: 'Saisissez un écart valide ou choisissez « Besoin d’aide ».', heightChoice: 'Indiquez si vous connaissez la hauteur de montage ou avez besoin d’aide.', heightValue: 'Saisissez les deux hauteurs ou choisissez « Besoin d’aide ».', appointment: 'Choisissez une date et une heure pour parler à l’opticien.', invalid: 'Vérifiez cette valeur avant de continuer.', upload: 'Téléverser l’ordonnance : choisissez une image ou un PDF.', opened: 'Assistant verres ouvert.', closed: 'Assistant verres fermé.' },
    de: { incomplete: 'Vervollständigen Sie diesen Schritt, um fortzufahren.', choose: 'Wählen Sie eine Option, um fortzufahren.', route: 'Wählen Sie, wie Sie Ihr Rezept übermitteln möchten.', rx: 'Geben Sie Ihr Rezept ein, laden Sie es hoch oder bitten Sie um Hilfe.', add: 'Bei Gleitsicht fehlt die Addition (ADD) für beide Augen.', pdChoice: 'Geben Sie an, ob Sie Ihren Pupillenabstand kennen oder Hilfe brauchen.', pdValue: 'Geben Sie einen gültigen Pupillenabstand ein oder wählen Sie Hilfe.', heightChoice: 'Geben Sie an, ob Sie die Einschleifhöhe kennen oder Hilfe brauchen.', heightValue: 'Geben Sie beide Höhen ein oder wählen Sie Hilfe.', appointment: 'Wählen Sie Datum und Uhrzeit für das Gespräch.', invalid: 'Prüfen Sie diesen Wert, bevor Sie fortfahren.', upload: 'Rezept hochladen: Bild oder PDF auswählen.', opened: 'Brillenglas-Assistent geöffnet.', closed: 'Brillenglas-Assistent geschlossen.' },
    ru: { incomplete: 'Заполните параметры этого шага, чтобы продолжить.', choose: 'Выберите вариант, чтобы продолжить.', route: 'Выберите, как передать рецепт.', rx: 'Введите или загрузите рецепт либо попросите помощь.', add: 'Для прогрессивных линз нужна аддидация (ADD) обоих глаз.', pdChoice: 'Укажите, знаете ли вы межзрачковое расстояние.', pdValue: 'Введите верное значение или выберите помощь.', heightChoice: 'Укажите, знаете ли вы высоту установки.', heightValue: 'Введите обе высоты или выберите помощь.', appointment: 'Выберите дату и время для разговора.', invalid: 'Проверьте значение перед продолжением.', upload: 'Загрузите рецепт: выберите изображение или PDF.', opened: 'Помощник по линзам открыт.', closed: 'Помощник по линзам закрыт.' },
    zh: { incomplete: '请完成本步骤的选项以继续。', choose: '请选择一个选项以继续。', route: '请选择提供处方的方式。', rx: '请输入或上传处方，也可以向验光师寻求帮助。', add: '渐进镜片需要双眼的下加光（ADD）数据。', pdChoice: '请选择您是否知道瞳距，或是否需要帮助。', pdValue: '请输入有效瞳距，或选择“需要帮助”。', heightChoice: '请选择您是否知道装配高度，或是否需要帮助。', heightValue: '请输入双眼装配高度，或选择“需要帮助”。', appointment: '请选择与验光师沟通的日期和时间。', invalid: '请检查该数值后再继续。', upload: '上传处方：请选择图片或 PDF 文件。', opened: '处方镜片助手已打开。', closed: '处方镜片助手已关闭。' }
  };

  /* OH_LENS_DRAFT_RESUME_V5: fail-closed, versioned and product-bound. */
  var DRAFT_KEY = 'oh_deferred_config';
  var DRAFT_VERSION = 5;
  var DRAFT_TTL = 14 * 24 * 60 * 60 * 1000;

  function clearDraft() {
    try { window.localStorage.removeItem(DRAFT_KEY); } catch (error) { /* unavailable */ }
  }

  function safeText(value, max) {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value !== 'string' || value.length > max || value.trim() !== value || /[<>&"'`\\\u0000-\u001f]/.test(value)) {
      throw new Error('invalid draft text');
    }
    return value;
  }

  function choice(value, allowed, nullable) {
    if (nullable && (value === null || value === undefined || value === '')) return null;
    if (allowed.indexOf(value) === -1) throw new Error('invalid draft choice');
    return value;
  }

  function flag(value, nullable, fallback) {
    if (value === undefined && fallback !== undefined) return fallback;
    if (nullable && value === null) return null;
    if (value !== true && value !== false) throw new Error('invalid draft flag');
    return value;
  }

  function numberValue(value, min, max, increment, zeroAllowed) {
    if (typeof value !== 'number' || !isFinite(value)) throw new Error('invalid draft number');
    if (zeroAllowed && value === 0) return 0;
    if (value < min || value > max || (increment && Math.abs(value / increment - Math.round(value / increment)) > 0.000001)) {
      throw new Error('draft number out of range');
    }
    return value;
  }

  function appointment(value) {
    if (value === null || value === undefined) return null;
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('invalid appointment');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value.date || '') || !/^([01]\d|2[0-3]):[0-5]\d$/.test(value.time || '')) {
      throw new Error('invalid appointment value');
    }
    return { date: value.date, time: value.time };
  }

  function sanitizeDraft(state) {
    try {
      if (!state || typeof state !== 'object' || Array.isArray(state)) throw new Error('invalid draft state');
      var rx = state.rx;
      var pd = state.pd;
      var height = state.height;
      if (!rx || !rx.od || !rx.oi || !pd || !height) throw new Error('incomplete draft state');
      if (state.uploadedUrl) throw new Error('prescription uploads are not resumable');
      function eye(value) {
        return {
          sph: numberValue(value.sph, -20, 20, 0.25, true),
          cyl: numberValue(value.cyl, -6, 0, 0.25, true),
          axis: numberValue(value.axis, 0, 180, 1, true),
          add: numberValue(value.add, 0.5, 3.5, 0.25, true)
        };
      }
      var step = choice(state.step, [3, 8], false);
      var output = {
        step: step,
        mode: choice(state.mode, ['frame', 'own'], false),
        type: choice(state.type, ['Monofocal', 'Progresivo'], false),
        quality: safeText(state.quality, 64),
        index: safeText(state.index, 16),
        treatment: safeText(state.treatment, 96),
        filter: safeText(state.filter, 96),
        color: safeText(state.color, 96),
        cgroup: safeText(state.cgroup, 96),
        finishKey: safeText(state.finishKey, 96),
        acabado: safeText(state.acabado, 96),
        filterKey: safeText(state.filterKey, 96),
        usage: choice(state.usage, ['near', 'far', 'both', 'screens', 'sport', '__nograd__'], true),
        suggestBlueLight: flag(state.suggestBlueLight, false, false),
        noGrad: flag(state.noGrad, false, false),
        rx: { od: eye(rx.od), oi: eye(rx.oi) },
        pd: {
          type: choice(pd.type, ['single', 'dual'], false),
          single: numberValue(pd.single, 50, 80, 0.5, true),
          odPd: numberValue(pd.odPd, 25, 40, 0.5, true),
          oiPd: numberValue(pd.oiPd, 25, 40, 0.5, true)
        },
        dpKnown: flag(state.dpKnown, true),
        height: {
          od: numberValue(height.od, 10, 40, 0.5, true),
          oi: numberValue(height.oi, 10, 40, 0.5, true)
        },
        heightKnown: flag(state.heightKnown, true),
        rx_route: choice(state.rx_route, ['manual', 'photo', 'optico', 'later'], true),
        rx_appointment: appointment(state.rx_appointment),
        uploadedUrl: null,
        _customQuote: flag(state._customQuote, false, false),
        _estimatedPrice: state._estimatedPrice === null || state._estimatedPrice === undefined
          ? null : numberValue(state._estimatedPrice, 0, 5000, 0.01, false)
      };
      if (!output.quality || (output.noGrad && step === 3) || (output.noGrad && output.usage !== '__nograd__')) {
        throw new Error('incoherent draft route');
      }
      if (step === 8 && (!output.treatment || !output.cgroup || !output.acabado || !output.filterKey)) {
        throw new Error('incomplete summary draft');
      }
      return output;
    } catch (error) {
      return null;
    }
  }

  function readDraft(api) {
    try {
      var raw = window.localStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      var payload = JSON.parse(raw);
      var now = Date.now();
      var timingOk = payload && typeof payload.ts === 'number' && typeof payload.expires === 'number' &&
        payload.ts <= now + 300000 && payload.expires > now && payload.expires - payload.ts <= DRAFT_TTL + 300000 && now - payload.ts <= DRAFT_TTL + 300000;
      if (!timingOk || payload.v !== DRAFT_VERSION || typeof payload.p !== 'string' || payload.p !== String(api.p || '') || payload.ctx !== window.location.pathname) {
        clearDraft();
        return null;
      }
      var state = sanitizeDraft(payload.state);
      if (!state) clearDraft();
      return state;
    } catch (error) {
      clearDraft();
      return null;
    }
  }

  function installDraftApi() {
    var api = window.OHLensDraftV5;
    if (!api || typeof api.restore !== 'function') return null;
    api.clear = clearDraft;
    api.read = function () { return readDraft(api); };
    return api;
  }

  installDraftApi();

  function init(root) {
    root = root || document;
    var overlay = root.querySelector ? root.querySelector('#ohLcOverlay') : null;
    if (!overlay || overlay.dataset.ohA11yBound === '1') return;
    overlay.dataset.ohA11yBound = '1';

    var modal = overlay.querySelector('.oh-lc-modal');
    var trigger = document.getElementById('ohLcTrigger');
    var draftApi = installDraftApi();
    var closeButton = document.getElementById('ohLcClose');
    var dialogTitle = overlay.querySelector('.oh-lc-header h2');
    var dialogDescription = overlay.querySelector('.oh-lc-header .oh-lc-product');
    var deferWrap = document.getElementById('ohWzDeferModal');
    var deferDialog = deferWrap && deferWrap.querySelector('[role="dialog"], .oh-modal');
    var lastFocus = null;
    var nestedLastFocus = null;
    var isOpen = false;
    var nestedOpen = false;
    var currentStep = null;
    var backgroundState = [];
    var bodyState = null;
    var enhanceQueued = false;
    var uid = 0;
    var lang = ((document.documentElement.lang || 'es').slice(0, 2)).toLowerCase();
    var text = COPY[lang] || COPY.es;

    if (!modal) return;
    ensureId(dialogTitle, 'ohLcDialogTitle');
    ensureId(dialogDescription, 'ohLcDialogDescription');
    setAttr(modal, 'role', 'dialog');
    setAttr(modal, 'aria-modal', 'true');
    setAttr(modal, 'aria-labelledby', dialogTitle && dialogTitle.id);
    if (dialogDescription) setAttr(modal, 'aria-describedby', dialogDescription.id);
    setAttr(modal, 'tabindex', '-1');
    setAttr(overlay, 'aria-hidden', overlay.classList.contains('oh-lc-open') ? 'false' : 'true');
    if (trigger) {
      setAttr(trigger, 'aria-haspopup', 'dialog');
      setAttr(trigger, 'aria-controls', 'ohLcOverlay');
      setAttr(trigger, 'aria-expanded', overlay.classList.contains('oh-lc-open') ? 'true' : 'false');
      trigger.addEventListener('pointerdown', rememberTrigger, { passive: true });
      trigger.addEventListener('keydown', rememberTrigger);
      trigger.addEventListener('click', function () {
        var draft = draftApi && draftApi.read();
        if (draft) draftApi.restore(draft);
      });
    }
    if (closeButton) setAttr(closeButton, 'type', 'button');

    var live = document.getElementById('ohLcA11yStatus');
    if (!live) {
      live = document.createElement('div');
      live.id = 'ohLcA11yStatus';
      live.className = 'oh-lc-sr-only';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      modal.appendChild(live);
    }

    var hint = null;
    ensureValidationHint();

    if (deferWrap && deferDialog) {
      setAttr(deferWrap, 'aria-hidden', deferWrap.hidden ? 'true' : 'false');
      setAttr(deferDialog, 'aria-modal', 'true');
      setAttr(deferDialog, 'role', 'dialog');
      setAttr(deferDialog, 'tabindex', '-1');
      var nestedTitle = deferDialog.querySelector('.t');
      ensureId(nestedTitle, 'ohWzDeferT');
      setAttr(deferDialog, 'aria-labelledby', nestedTitle && nestedTitle.id);
    }

    enhance();
    syncOpenState();
    if (trigger && window.location.hash === '#ohLcTrigger' && trigger.dataset.ohHashOpenedV5 !== '1') {
      trigger.dataset.ohHashOpenedV5 = '1';
      window.setTimeout(function () {
        safeFocus(trigger);
        if (!overlay.classList.contains('oh-lc-open')) trigger.click();
      }, 0);
    }

    var observer = new MutationObserver(function (mutations) {
      var needsEnhance = false;
      mutations.forEach(function (mutation) {
        if (mutation.target === overlay && mutation.attributeName === 'class') syncOpenState();
        if (deferWrap && mutation.target === deferWrap && mutation.attributeName === 'hidden') syncNestedState();
        needsEnhance = true;
      });
      if (needsEnhance) queueEnhance();
    });
    observer.observe(overlay, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'disabled', 'aria-selected', 'aria-checked']
    });

    document.addEventListener('keydown', onDocumentKeydown, true);
    modal.addEventListener('keydown', onWidgetKeydown, true);
    modal.addEventListener('click', queueEnhance);
    modal.addEventListener('change', validateControl, true);
    modal.addEventListener('input', queueEnhance, true);
    modal.addEventListener('blur', validateControl, true);

    function rememberTrigger() {
      lastFocus = trigger || document.activeElement;
    }

    function syncOpenState() {
      var nowOpen = overlay.classList.contains('oh-lc-open');
      if (nowOpen === isOpen) return;
      isOpen = nowOpen;
      if (isOpen) openDialog(); else closeDialog();
    }

    function openDialog() {
      if (!lastFocus || !document.documentElement.contains(lastFocus)) lastFocus = document.activeElement || trigger;
      setAttr(overlay, 'aria-hidden', 'false');
      if (trigger) setAttr(trigger, 'aria-expanded', 'true');
      isolateBackground();
      lockScroll();
      window.setTimeout(function () {
        enhance();
        var heading = activeHeading() || dialogTitle || modal;
        if (heading !== modal) setAttr(heading, 'tabindex', '-1');
        safeFocus(heading);
        announce(text.opened);
      }, 0);
    }

    function closeDialog() {
      if (nestedOpen && deferWrap) {
        deferWrap.hidden = true;
        syncNestedState();
      }
      setAttr(overlay, 'aria-hidden', 'true');
      if (trigger) setAttr(trigger, 'aria-expanded', 'false');
      restoreBackground();
      unlockScroll();
      announce(text.closed);
      var destination = lastFocus && document.documentElement.contains(lastFocus) ? lastFocus : trigger;
      window.setTimeout(function () { safeFocus(destination); }, 0);
    }

    function syncNestedState() {
      if (!deferWrap || !deferDialog) return;
      var nowOpen = !deferWrap.hidden;
      setAttr(deferWrap, 'aria-hidden', nowOpen ? 'false' : 'true');
      if (nowOpen === nestedOpen) return;
      nestedOpen = nowOpen;
      if (nestedOpen) {
        nestedLastFocus = document.activeElement;
        var nestedTitle = deferDialog.querySelector('.t');
        if (nestedTitle) setAttr(nestedTitle, 'tabindex', '-1');
        window.setTimeout(function () { safeFocus(nestedTitle || firstFocusable(deferDialog) || deferDialog); }, 0);
      } else {
        var destination = nestedLastFocus && document.documentElement.contains(nestedLastFocus) ? nestedLastFocus : document.getElementById('ohWzDeferLink');
        window.setTimeout(function () { safeFocus(destination); }, 0);
      }
    }

    function onDocumentKeydown(event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (nestedOpen && deferWrap) {
          deferWrap.hidden = true;
          syncNestedState();
        } else {
          overlay.classList.remove('oh-lc-open');
          syncOpenState();
        }
        return;
      }
      if (event.key !== 'Tab') return;
      var scope = nestedOpen && deferDialog ? deferDialog : modal;
      trapTab(event, scope);
    }

    function onWidgetKeydown(event) {
      var target = event.target.closest && event.target.closest('[role="radio"], [role="button"]');
      if (!target) return;
      if ((event.key === 'Enter' || event.key === ' ') && !/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
        event.preventDefault();
        target.click();
        return;
      }
      if (target.getAttribute('role') !== 'radio') return;
      var group = target.closest('[role="radiogroup"]');
      if (!group) return;
      var radios = visibleElements(group.querySelectorAll('[role="radio"]')).filter(function (node) {
        return node.getAttribute('aria-disabled') !== 'true';
      });
      if (!radios.length) return;
      var index = radios.indexOf(target);
      var nextIndex = index;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % radios.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + radios.length) % radios.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = radios.length - 1;
      else return;
      event.preventDefault();
      var requestedText = (radios[nextIndex].textContent || '').trim();
      radios[nextIndex].tabIndex = 0;
      safeFocus(radios[nextIndex]);
      radios[nextIndex].click();
      // OH_LENS_CONFIGURATOR_RADIO_FOCUS_V2: the legacy click handler may
      // rebuild the option node. Restore focus after that DOM replacement.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          enhance();
          var scope = group.isConnected ? group : modal;
          var refreshed = visibleElements(scope.querySelectorAll('[role="radio"]')).filter(function (node) {
            return node.getAttribute('aria-disabled') !== 'true';
          });
          var selected = refreshed.find(function (node) {
            return (node.textContent || '').trim() === requestedText;
          }) || refreshed.find(function (node) {
            return node.getAttribute('aria-checked') === 'true';
          });
          safeFocus(selected);
        });
      });
    }

    function enhance() {
      enhanceQueued = false;
      enhanceLabels();
      enhanceRadioGroups();
      enhanceRoutes();
      enhanceToggles();
      enhanceNavigation();
      enhanceUpload();
      enhanceValidationHint();
      syncNestedState();
      announceStepIfChanged();
    }

    function queueEnhance() {
      if (enhanceQueued) return;
      enhanceQueued = true;
      window.requestAnimationFrame(enhance);
    }

    function enhanceLabels() {
      modal.querySelectorAll('.oh-lc-rx-field').forEach(function (field) {
        var control = field.querySelector('input, select, textarea');
        var label = field.querySelector('label');
        if (!control) return;
        ensureId(control, 'ohLcField' + (++uid));
        if (label) setAttr(label, 'for', control.id);
        setAttr(control, 'autocomplete', 'off');
        if (label && label.querySelector('.req')) {
          setAttr(control, 'aria-required', 'true');
        }
        syncControlValidity(control, false);
      });
      [['ohWzCamInput', text.upload], ['ohWzFileInput', text.upload], ['ohRxFile', text.upload]].forEach(function (item) {
        var input = document.getElementById(item[0]);
        if (input) setAttr(input, 'aria-label', item[1]);
      });
    }

    function enhanceRadioGroups() {
      modal.querySelectorAll('.oh-lc-options, #ohLcIxSelector').forEach(function (group) {
        var options = group.querySelectorAll('.oh-lc-opt, .oh-lc-ix-opt');
        if (!options.length) return;
        setAttr(group, 'role', 'radiogroup');
        labelGroup(group);
        var hasSelected = !!group.querySelector('.selected');
        options.forEach(function (option, index) {
          var checked = option.classList.contains('selected');
          var disabled = option.classList.contains('disabled');
          setAttr(option, 'role', 'radio');
          setAttr(option, 'aria-checked', checked ? 'true' : 'false');
          setAttr(option, 'aria-disabled', disabled ? 'true' : 'false');
          option.tabIndex = checked || (!hasSelected && index === 0) ? 0 : -1;
        });
      });
    }

    function enhanceRoutes() {
      var group = document.getElementById('ohWzRoutes');
      if (!group) return;
      setAttr(group, 'role', 'group');
      labelGroup(group);
      group.querySelectorAll('.expanded-card-wrap').forEach(function (wrap, index) {
        var button = wrap.querySelector('.oh-option[data-route]');
        var panel = wrap.querySelector('.wz-expanded');
        if (!button || !panel) return;
        ensureId(button, 'ohLcRoute' + (++uid));
        ensureId(panel, button.id + 'Panel');
        var open = wrap.classList.contains('open');
        setAttr(button, 'role', null);
        setAttr(button, 'aria-checked', null);
        setAttr(button, 'aria-expanded', open ? 'true' : 'false');
        setAttr(button, 'aria-controls', panel.id);
        setAttr(panel, 'role', 'region');
        setAttr(panel, 'aria-labelledby', button.id);
        setAttr(panel, 'aria-hidden', open ? 'false' : 'true');
        panel.inert = !open;
        button.tabIndex = 0;
      });
    }

    function enhanceToggles() {
      modal.querySelectorAll('#ohPdKnow, #ohHeightKnow, .oh-lc-pd-type, .oh-date-strip, .oh-time').forEach(function (group) {
        var buttons = group.querySelectorAll('button');
        if (!buttons.length) return;
        setAttr(group, 'role', 'radiogroup');
        labelGroup(group);
        var hasActive = false;
        buttons.forEach(function (button) {
          var active = button.classList.contains('active') || button.getAttribute('aria-selected') === 'true';
          hasActive = hasActive || active;
          setAttr(button, 'role', 'radio');
          setAttr(button, 'aria-checked', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
        });
        if (!hasActive && buttons[0]) buttons[0].tabIndex = 0;
      });
      var save = document.getElementById('ohWzSaveRx');
      if (save) setAttr(save, 'aria-label', (save.querySelector('.t') || save).textContent.trim());
    }

    function enhanceNavigation() {
      modal.querySelectorAll('.oh-lc-pstep.done, .oh-lc-pstep.active, .oh-side-step.done, .oh-side-step.active').forEach(function (step) {
        setAttr(step, 'role', 'button');
        step.tabIndex = 0;
        setAttr(step, 'aria-current', step.classList.contains('active') ? 'step' : null);
      });
    }

    function enhanceUpload() {
      var drop = document.getElementById('ohWzDrop');
      if (!drop) return;
      setAttr(drop, 'role', 'button');
      setAttr(drop, 'aria-label', text.upload);
      if (!drop.hasAttribute('tabindex')) drop.tabIndex = 0;
      var progress = document.getElementById('ohWzUploadProg');
      var bar = document.getElementById('ohWzUpFill');
      if (progress) {
        setAttr(progress, 'role', 'status');
        setAttr(progress, 'aria-live', 'polite');
      }
      if (bar) {
        var percentage = parseInt(bar.style.width, 10);
        setAttr(bar, 'role', 'progressbar');
        setAttr(bar, 'aria-valuemin', '0');
        setAttr(bar, 'aria-valuemax', '100');
        setAttr(bar, 'aria-valuenow', isNaN(percentage) ? '0' : String(percentage));
      }
    }

    function enhanceValidationHint() {
      ensureValidationHint();
      var next = document.getElementById('ohBtnNext');
      if (!next || !hint) return;
      var disabled = !!next.disabled;
      hint.textContent = validationMessage();
      hint.hidden = !disabled;
      setAttr(next, 'aria-disabled', disabled ? 'true' : 'false');
      setAttr(next, 'aria-describedby', disabled ? hint.id : null);
    }

    function ensureValidationHint() {
      var nav = document.getElementById('ohLcNav');
      if (!nav) return null;
      var connected = document.getElementById('ohLcValidationHint');
      if (connected) hint = connected;
      if (!hint || !hint.isConnected) {
        hint = document.createElement('p');
        hint.id = 'ohLcValidationHint';
        hint.className = 'oh-lc-validation-hint';
        hint.setAttribute('role', 'status');
        hint.setAttribute('aria-live', 'polite');
        hint.textContent = text.incomplete;
        hint.hidden = true;
      }
      if (hint.parentNode !== nav) nav.insertBefore(hint, nav.lastElementChild || null);
      return hint;
    }

    function validationMessage() {
      var active = modal.querySelector('.oh-lc-step.active');
      var step = active && active.getAttribute('data-step');
      if (step === '0' || step === '1' || step === '2' || step === '4' || step === '5' || step === '6' || step === '7') {
        return text.choose;
      }
      if (step !== '3') return text.incomplete;

      var routeButton = modal.querySelector('.oh-option[data-route][aria-expanded="true"], .expanded-card-wrap.open .oh-option[data-route]');
      var route = routeButton && routeButton.getAttribute('data-route');
      if (!route) return text.route;
      if (route === 'photo') {
        var file = document.getElementById('ohWzFileInput') || document.getElementById('ohRxFile');
        var uploadName = document.getElementById('ohRxFileName');
        var uploaded = !!(file && file.files && file.files.length) || !!(uploadName && uploadName.getClientRects().length && uploadName.textContent.trim());
        if (!uploaded) return text.upload;
      }
      if (route === 'optico') {
        var dateSelected = modal.querySelector('.oh-date-strip button.active, .oh-date-strip button[aria-checked="true"]');
        var timeSelected = modal.querySelector('.oh-time.active, .oh-time[aria-checked="true"], .oh-time button.active, .oh-time button[aria-checked="true"]');
        if (!dateSelected || !timeSelected) return text.appointment;
      }
      if (route === 'manual') {
        var number = function (id) {
          var control = document.getElementById(id);
          return control ? (parseFloat(control.value) || 0) : 0;
        };
        var progressive = !!document.querySelector('.oh-lc-rx-add-row.show') || !!(document.getElementById('ohHeightSection') && window.getComputedStyle(document.getElementById('ohHeightSection')).display !== 'none');
        var hasDistancePower = [number('ohRxOdSph'), number('ohRxOiSph'), number('ohRxOdCyl'), number('ohRxOiCyl')].some(function (value) { return value !== 0; });
        var hasAdd = number('ohRxOdAdd') > 0 && number('ohRxOiAdd') > 0;
        if (!hasDistancePower && !(progressive && hasAdd)) return text.rx;
        if (progressive && !hasAdd) return text.add;
      }

      var pdYes = modal.querySelector('#ohPdKnow button[data-know="yes"].active, #ohPdKnow button[data-know="yes"][aria-checked="true"]');
      var pdNo = modal.querySelector('#ohPdKnow button[data-know="no"].active, #ohPdKnow button[data-know="no"][aria-checked="true"]');
      if (!pdYes && !pdNo) return text.pdChoice;
      if (pdYes) {
        var pdTypeDual = !!modal.querySelector('.oh-lc-pd-type button[data-pd="dual"].active, .oh-lc-pd-type button[data-pd="dual"][aria-checked="true"]');
        var pdSingle = parseFloat((document.getElementById('ohPdSingle') || {}).value) || 0;
        var pdOd = parseFloat((document.getElementById('ohPdOd') || {}).value) || 0;
        var pdOi = parseFloat((document.getElementById('ohPdOi') || {}).value) || 0;
        var pdValid = pdTypeDual ? (pdOd >= 25 && pdOd <= 40 && pdOi >= 25 && pdOi <= 40) : (pdSingle >= 50 && pdSingle <= 80);
        if (!pdValid) return text.pdValue;
      }

      var heightSection = document.getElementById('ohHeightSection');
      var progressiveHeight = !!(heightSection && window.getComputedStyle(heightSection).display !== 'none');
      if (progressiveHeight) {
        var heightYes = modal.querySelector('#ohHeightKnow button[data-know="yes"].active, #ohHeightKnow button[data-know="yes"][aria-checked="true"]');
        var heightNo = modal.querySelector('#ohHeightKnow button[data-know="no"].active, #ohHeightKnow button[data-know="no"][aria-checked="true"]');
        if (!heightYes && !heightNo) return text.heightChoice;
        if (heightYes) {
          var heightOd = parseFloat((document.getElementById('ohHeightOd') || {}).value) || 0;
          var heightOi = parseFloat((document.getElementById('ohHeightOi') || {}).value) || 0;
          if (!(heightOd >= 10 && heightOd <= 40 && heightOi >= 10 && heightOi <= 40)) return text.heightValue;
        }
      }
      return text.incomplete;
    }

    function validateControl(event) {
      var control = event.target;
      if (!control.matches || !control.matches('.oh-lc-rx-field input, .oh-lc-rx-field select')) return;
      syncControlValidity(control, true);
    }

    function syncControlValidity(control, announceError) {
      var field = control.closest('.oh-lc-rx-field');
      if (!field) return;
      var hasValue = String(control.value || '').trim() !== '';
      var invalid = hasValue && typeof control.checkValidity === 'function' && !control.checkValidity();
      setAttr(control, 'aria-invalid', invalid ? 'true' : 'false');
      var error = field.querySelector('.oh-lc-field-error');
      if (invalid && !error) {
        error = document.createElement('span');
        error.className = 'oh-lc-field-error';
        error.id = control.id + 'Error';
        error.textContent = text.invalid;
        field.appendChild(error);
      }
      if (error) error.hidden = !invalid;
      setDescription(control, invalid && error ? error.id : null);
      if (invalid && announceError) announce(text.invalid);
    }

    function announceStepIfChanged() {
      var active = modal.querySelector('.oh-lc-step.active');
      var step = active && active.getAttribute('data-step');
      if (!isOpen || step === null || step === currentStep) return;
      var previous = currentStep;
      currentStep = step;
      var heading = activeHeading();
      if (heading) announce(heading.textContent.trim());
      if (previous !== null && heading) {
        setAttr(heading, 'tabindex', '-1');
        window.setTimeout(function () { safeFocus(heading); }, 0);
      }
    }

    function activeHeading() {
      var active = modal.querySelector('.oh-lc-step.active');
      return active && active.querySelector('h1, h2, h3, [role="heading"]');
    }

    function isolateBackground() {
      if (backgroundState.length) return;
      var node = overlay;
      while (node && node !== document.body) {
        var parent = node.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sibling) {
          if (sibling === node || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          backgroundState.push({
            node: sibling,
            inert: !!sibling.inert,
            ariaHidden: sibling.getAttribute('aria-hidden')
          });
          sibling.inert = true;
          sibling.setAttribute('aria-hidden', 'true');
        });
        node = parent;
      }
    }

    function restoreBackground() {
      backgroundState.forEach(function (state) {
        if (!state.node || !document.documentElement.contains(state.node)) return;
        state.node.inert = state.inert;
        if (state.ariaHidden === null) state.node.removeAttribute('aria-hidden');
        else state.node.setAttribute('aria-hidden', state.ariaHidden);
      });
      backgroundState = [];
    }

    function lockScroll() {
      if (bodyState) return;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      bodyState = {
        y: y,
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };
      document.documentElement.classList.add('oh-lc-scroll-lock');
      document.body.classList.add('oh-lc-scroll-lock');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + y + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    function unlockScroll() {
      if (!bodyState) return;
      var saved = bodyState;
      bodyState = null;
      document.documentElement.classList.remove('oh-lc-scroll-lock');
      document.body.classList.remove('oh-lc-scroll-lock');
      document.body.style.position = saved.position;
      document.body.style.top = saved.top;
      document.body.style.left = saved.left;
      document.body.style.right = saved.right;
      document.body.style.width = saved.width;
      document.body.style.overflow = saved.overflow;
      window.scrollTo(0, saved.y);
    }

    function trapTab(event, scope) {
      var focusable = visibleElements(scope.querySelectorAll(SELECTOR_FOCUSABLE)).filter(function (node) {
        return !node.closest('[inert]') && node.getAttribute('aria-hidden') !== 'true';
      });
      if (!focusable.length) {
        event.preventDefault();
        safeFocus(scope);
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!scope.contains(document.activeElement)) {
        event.preventDefault();
        safeFocus(event.shiftKey ? last : first);
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        safeFocus(last);
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        safeFocus(first);
      }
    }

    function firstFocusable(scope) {
      return visibleElements(scope.querySelectorAll(SELECTOR_FOCUSABLE))[0] || null;
    }

    function labelGroup(group) {
      if (group.hasAttribute('aria-label') || group.hasAttribute('aria-labelledby')) return;
      var step = group.closest('.oh-lc-step');
      var heading = step && step.querySelector('h2, h3, h4');
      if (heading) {
        ensureId(heading, 'ohLcHeading' + (++uid));
        setAttr(group, 'aria-labelledby', heading.id);
      }
    }

    function announce(message) {
      if (!live || !message) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = message; }, 20);
    }
  }

  function visibleElements(nodes) {
    return Array.prototype.filter.call(nodes, function (node) {
      if (!node || node.hidden) return false;
      var style = window.getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden' && node.getClientRects().length > 0;
    });
  }

  function ensureId(node, fallback) {
    if (!node) return null;
    if (!node.id) node.id = fallback;
    return node.id;
  }

  function setAttr(node, name, value) {
    if (!node) return;
    if (value === null || value === undefined || value === '') {
      if (node.hasAttribute(name)) node.removeAttribute(name);
      return;
    }
    value = String(value);
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function setDescription(control, id) {
    var current = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    current = current.filter(function (token) { return !/Error$/.test(token); });
    if (id && current.indexOf(id) === -1) current.push(id);
    setAttr(control, 'aria-describedby', current.length ? current.join(' ') : null);
  }

  function safeFocus(node) {
    if (!node || typeof node.focus !== 'function') return;
    try { node.focus({ preventScroll: true }); } catch (error) { node.focus(); }
  }

  function start() {
    init(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
})();
